import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { STATIC_DATASETS_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { get_automation_static_datasets_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { StaticDataset, StaticDatasets } from '@/types/datasets.ts';

import { fetchDatasetInventory } from '@/hooks/api/datasets/fetchDatasetInventory.ts';

const useRetrieveStaticDatasets = (): UseQueryResult<StaticDatasets, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: STATIC_DATASETS_KEY(automationId),
    queryFn: ({ signal }) =>
      fetchDatasetInventory<StaticDataset>(
        apiClient,
        get_automation_static_datasets_url(automationId),
        signal,
      ),
    enabled: !!automationId,
  });
};

export default useRetrieveStaticDatasets;
